import React, { useState, useRef, useEffect } from "react";
import { LoaderCircle, Menu, Search, ShoppingBag, X } from "lucide-react";
import classNames from "classnames/bind";
import styles from "./MobileHeader.module.scss";
import Logo from "../Logo/Logo";
import { useCartSidebarStore } from "../../stores/Cart/cartSidebarStore";
import SearchSuggestions from "../SearchSuggestions/SearchSuggestions";
import useDebounce from "../../hooks/useDebounce";
import { searchProducts } from "../../services/Products/ProductServices";

const cx = classNames.bind(styles);

const MobileHeader = ({
  toggleMobileMenu,
  
}) => {

  const toggle = useCartSidebarStore((state) => state.toggle);
  const [isSearchDropdownOpen, setIsSearchDropdownOpen] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const searchInputRef = useRef(null);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const searchRef = useRef(null);

  const [searchResults, setSearchResults] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const debouncedValueSearch = useDebounce(searchValue, 500);

  useEffect(() => {
    const fetchSearch = async () => {
      if (!debouncedValueSearch.trim()) {
        return;
      }
      setIsLoading(true);
      let res = await searchProducts(debouncedValueSearch, 7);

      if (res) {
        setSearchResults(res);
      }
      setIsLoading(false);
      setShowSuggestions(true);
    };
    fetchSearch();
  }, [debouncedValueSearch]);

  // Click outside để đóng suggestions
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (searchRef.current && !searchRef.current.contains(event.target)) {
        setShowSuggestions(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  // Auto focus when search opens
  useEffect(() => {
    if (isSearchDropdownOpen && searchInputRef.current) {
      searchInputRef.current.focus();
    }
  }, [isSearchDropdownOpen]);

  const handleSearchToggle = () => {
    setIsSearchDropdownOpen(!isSearchDropdownOpen);
    if (isSearchDropdownOpen) {
      setSearchValue("");
    }
  };

  const handleSearchClose = () => {
    setIsSearchDropdownOpen(false);
    setSearchValue("");
  };

  return (
    <div className={cx("mobile-header")}>
      <div className={cx("mobile-header__top")}>
        <div className={cx("mobile-header__left")}>
          <button
            className={cx("mobile-header__menu-button")}
            onClick={toggleMobileMenu}
            aria-label="Toggle menu"
          >
            <Menu size={24} />
          </button>

          <button
            className={cx("mobile-header__search-button")}
            onClick={handleSearchToggle}
            aria-label="Toggle search"
          >
            <Search size={20} />
          </button>
        </div>

        <Logo className={cx("mobile-header__logo")} />

        <button
          className={cx("mobile-header__cart-button")}
          onClick={() => {
            toggle();
          }}
          aria-label="Shopping cart"
        >
          <ShoppingBag size={20} />
        </button>
      </div>

      {/* Search Dropdown */}
      <div
        className={cx("mobile-header__search-dropdown", {
          "mobile-header__search-dropdown--open": isSearchDropdownOpen,
        })}
      >
        <div className={cx("mobile-header__search-container")}>
          {/* <form onSubmit={handleSearchSubmit}> */}
          <div style={{ position: "relative" }}>
            {isLoading ? (
              <LoaderCircle
                size={20}
                className={cx("mobile-header__search-icon", {
                  loader: isLoading,
                })}
              />
            ) : (
              <Search size={20} className={cx("mobile-header__search-icon")} />
            )}

            <input
              ref={searchInputRef}
              type="text"
              placeholder="Tìm kiếm sản phẩm..."
              value={searchValue}
              onChange={(e) => setSearchValue(e.target.value)}
              className={cx("mobile-header__search-input")}
            />

            <SearchSuggestions
              isVisible={showSuggestions}
              searchResults={searchResults}
              isMobile={true}
            />

            <X
              size={30}
              className={cx("mobile-header__close-icon")}
              onClick={handleSearchClose}
            />
          </div>
          {/* </form> */}
        </div>
      </div>
    </div>
  );
};

export default MobileHeader;
